import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconShieldProtected4 = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h24v24h-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M20,11.182c0,4.541 -3.413,8.787 -8,9.818c-4.587,-1.031 -8,-5.277 -8,-9.818v-3.567c0,-0.812 0.491,-1.544 1.243,-1.851l5,-2.046c1.126,-0.461 2.388,-0.461 3.514,0l5,2.046c0.752,0.308 1.243,1.039 1.243,1.851v3.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M15.25,10.125l-3.75,3.75l-2.25,-2.25"
  })));
};
//# sourceMappingURL=IconShieldProtected4.js.map